import { useEffect, useState } from "react";

import utility from "core/Utils";
import IconInput from "components/elements/IconInput";
import Table from "components/elements/Table";
import Modal from "components/elements/Modal";
import Select from "components/elements/Select";

import { ReactComponent as ArrowIcon } from "../../../images/arrow-small-left.svg";
import { ReactComponent as DownloadIcon } from "../../../images/download.svg";

const headerMap = {
  name: "FileName",
  type: "Type",
  status: "Status",
};

const FileDetailsDetailed = props => {
  const [detailedData, setDetailedData] = useState([]);

  const [showColModal, setShowColModal] = useState(false);
  const [columns] = useState(utility.optionFromObject(headerMap));
  const [selectedColumns, setSelectedColumns] = useState(
    utility.optionFromObject(headerMap)
  );

  useEffect(() => {
    let detailData = [];
    let data = props.data;
    let selectedDetails = props.selectedDetails;

    for (let i = 0; i < data.length; i++) {
      if (
        data[i].type === selectedDetails.type &&
        data[i].status === selectedDetails.status
      ) {
        detailData.push(data[i]);
      }
    }

    setDetailedData(detailData);
  }, [props]);

  const colModal = (
    <Modal onClose={() => setShowColModal(false)}>
      <h3>Select Columns</h3>
      <div className="full-row" style={{ width: "50vw", marginTop: "2rem" }}>
        <Select
          isMulti
          value={selectedColumns}
          options={columns}
          placeholder="Select columns to show"
          onChange={val => setSelectedColumns(val)}
        />
      </div>
    </Modal>
  );

  return (
    <div className="results-wrapper flex-full">
      {showColModal && colModal}
      <div className="head flex flex-v-center">
        <div
          className="circle-button"
          style={{ marginRight: "1rem" }}
          onClick={() => {
            props.showDetails(null);
          }}
        >
          <ArrowIcon />
        </div>
        <h3>Results</h3>
        <div className="right">
          <div className="flex flex-v-center">
            <div className="el">
              <input
                type="text"
                readOnly
                placeholder="Select Columns"
                onClick={e => {
                  e.preventDefault();
                  setShowColModal(true);
                }}
              />
            </div>
            <div className="el">
              <IconInput placeholder="Search" icon="search" />
            </div>
          </div>
        </div>
      </div>
      <div className="results">
        <Table
          headers={utility.objectFromOptions(selectedColumns)}
          data={detailedData}
        />
      </div>
    </div>
  );
};

export default FileDetailsDetailed;
